import type { ExternalTableSchema } from '@packages/table-builder';

export const feeTable: ExternalTableSchema = {
  metadata: {
    title: 'Fee',
    entity: 'Fee',
    description: 'List of SEC fees.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/fee/sec-fee-list',
    method: 'GET',
    rowIdField: 'id',
    itemsTransformId: 'fee',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'effectiveDate',
      header: 'Effective Date',
      type: 'date',
      width: 180,
      align: 'left',
    },
    {
      field: 'rate',
      header: 'Rate ($)',
      type: 'currency',
      width: 180,
      align: 'left',
      prefix: '$',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_FEE', label: 'View' },
      { id: 'EDIT_FEE', label: 'Edit' },
      { id: 'DELETE_FEE', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_FEE',
        label: 'Add SEC Fee',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
  },
};
